import { makeAutoObservable } from 'mobx';
import { InvitationManager } from '../../../../core-logic/modules/authorization/managers/InvitationManager';

class InvitationUIManager {
  constructor(private invitationManager: InvitationManager) {
    makeAutoObservable(this, {});
  }

  get coreManager() {
    return this.invitationManager;
  }
}

export { InvitationUIManager };
